module.exports = __webpack_public_path__ + "static/media/header-image-sm.0b32f78b.jpg";